module.exports = __webpack_public_path__ + "img/SES_194258700.ef786431.jpg";